import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  LhChange,
  LhSingleOptionSelectEvent,
  PatternlibCheckboxCustomEvent,
  PatternlibDropdownsubtleCustomEvent,
  PatternlibPaginationCustomEvent,
} from "@liebherr/patternlib/dist/types/components";
import { DocumentInfo } from "src/app/models/document-info.model";
import { DocumentsService } from "src/app/services/documents.service";

export class TableRow {
  selected = false;
  constructor(public data: DocumentInfo) {}
}

@Component({
  selector: "lh-docs-list",
  templateUrl: "./docs-list.component.html",
  styleUrls: ["./docs-list.component.scss"],
})
export class DocsListComponent implements OnInit {
  //@Input()
  //list: DocumentInfoListResult | null = null;

  @Input()
  rows: TableRow[] = [];

  selectedAll = false;
  downloadEndpointUrl: string | null = null;

  currentPage = 1;
  itemsPerPage = 10;

  @Output()
  needsRefresh = new EventEmitter();

  @Output()
  selectedRows = new EventEmitter();

  constructor(
    private docsService: DocumentsService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.docsService
      .getDownloadEndpointUrl()
      .then((url) => (this.downloadEndpointUrl = url))
      .catch(() => {
        const referer = "/" + this.route.snapshot.url.toString();
        this.router.navigateByUrl(`/error?referer=${referer}`);
      });
  }

  getDownloadLink(doc: DocumentInfo): string {
    if (!this.downloadEndpointUrl) {
      return "#";
    }
    return (
      `${this.downloadEndpointUrl}?documentId=` +
      encodeURIComponent(doc.documentId)
    );
  }

  getSelectedIds(): string[] {
    return this.rows.filter((r) => r.selected).map((r) => r.data.documentId);
  }

  onSelectRow(
    tableRow: TableRow,
    event: PatternlibCheckboxCustomEvent<LhChange>,
  ) {
    tableRow.selected = event.detail.value as boolean;
    this.onRowSelected();
  }

  onRowSelected() {
    this.selectedAll =
      this.getSelectedIds().length === this.documentsOnThisPage.length;
    this.selectedRows.emit(this.getSelectedIds());
  }

  onSelectAllRows(event: PatternlibCheckboxCustomEvent<LhChange>) {
    this.selectAllRows(event.detail.value as boolean);
  }

  selectAllRows(selected: boolean) {
    for (const row of this.documentsOnThisPage) {
      row.selected = selected;
    }

    this.onRowSelected();
  }

  refresh() {
    this.needsRefresh.emit();
  }

  get pageIndexStart() {
    return (this.currentPage - 1) * this.itemsPerPage;
  }

  get pageIndexEnd() {
    return Math.min(this.pageIndexStart + this.itemsPerPage, this.rows.length);
  }

  get documentsOnThisPage() {
    return this.rows.slice(this.pageIndexStart, this.pageIndexEnd);
  }

  get lastPage() {
    return Math.ceil(this.rows.length / this.itemsPerPage);
  }

  onPageChange(event: PatternlibPaginationCustomEvent<LhChange>) {
    this.currentPage = +event.detail.value;
    for (const row of this.rows) {
      row.selected = false;
    }
    this.onRowSelected();
  }

  onItemsPerPageChange(
    event: PatternlibDropdownsubtleCustomEvent<LhSingleOptionSelectEvent>,
  ) {
    this.itemsPerPage = +event.detail.selected!.value;
    for (const row of this.rows) {
      row.selected = false;
    }
    this.onRowSelected();
  }

  get fileNameAvailable() {
    return this.rows.some((row) => row.data.fileName);
  }

  get fileSizeAvailable() {
    return this.rows.some((row) => row.data.fileSize && row.data.fileSize > 0);
  }

  get pageCountAvailable() {
    return this.rows.some(
      (row) => row.data.pageCount && row.data.pageCount > 0,
    );
  }

  get categoriesAvailable() {
    return this.rows.some((row) => row.data.category);
  }
}
